export const mobileBackgroundRssNames = {
  backgroundFirstLayer: 'backgroundFirstLayer',
  plusIcon: 'deposit_plus_icon',
  backgroundSecondLayer: 'backgroundSecondLayer',
  homeIcon: 'home_button',
  lastResultsOpacity: 'last_results_opacity',
  shadow: 'shadow',
  plants: 'plants',
  preBonusPlants: 'preBonusPlants',
  preBonusStoneSpine: 'preBonusStoneSpine',
  stoneSpine: 'stoneSpine',
  preBonusBackgroundFirstLayer: 'preBonusBackgroundFirstLayer',
  preBonusBackgroundSecondLayer: 'preBonusBackgroundSecondLayer',
  crystalLogo: 'crystalLogo',
  bonusBackgroundFirstLayer: 'mobileBackgroundRssNames_bonusBackgroundFirstLayer',
  bonusBackgroundSecondLayer: 'mobileBackgroundRssNames_bonusBackgroundSecondLayer',
  bonusPlants: 'bonusPlants',
  bonusStoneSpine: 'bonusStoneSpine',
  bonusTreeSpine: 'bonusTreeSpine',
  logoSpine: 'logoSpine_Spine',
};

export const mobileWheelRssNames = {
  wheelSpine: 'wheelSpine',
};

export const mobileGameRssNames = {
  spinIcon: 'spin_icon',
  autoSpinIcon: 'auto_spin_icon',
  betAmountIcon: 'bet_amount_icon',
  buttonBorderNonActive: 'button_border_active',
  buttonBorderActive: 'button_border_non_active',
  autoplayIcon: 'autoplay_icon',
  leftArrowIcon: 'left_arrow_icon',
  rightArrowIcon: 'right_arrow_icon',
  betAmountMinus: 'bet_amount_minus',
  betAmountPlus: 'bet_amount_plus',
  mobileController: 'mobile_controller',
  infinityIcon: 'infinity_icon',
  infinityIconDark: 'infinity_icon_dark',
};

export const mobileBonusBoardRssNames = {
  bonus_button_mobile: 'bonus_button_mobile',
  bonus_buttonAnimation: 'bonus_button_mobile_animation',
};

export const mobileControlRssNames = {
  infoIcon: 'infoIcon',
  infoIconActive: 'infoIconActive',
  soundOnIcon: 'soundOnIcon',
  soundOffIcon: 'soundOffIcon',
  historyIcon: 'historyIcon',
  historyIconActive: 'historyIconActive',
};

export const screenChangeMobileAnimationNames = {
  mainToPreBonus: 'mobile_mainToPreBonus_screenChange',
  preBonusToBonus: 'mobile_preBonusToBonus_screenChange',
  bonusToMain: 'mobile_bonusToMain_screenChange',
};
